import { render, staticRenderFns } from "./ScheduleEventAttachmentsInput.vue?vue&type=template&id=117b4027&"
import script from "./ScheduleEventAttachmentsInput.vue?vue&type=script&lang=js&"
export * from "./ScheduleEventAttachmentsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117b4027')) {
      api.createRecord('117b4027', component.options)
    } else {
      api.reload('117b4027', component.options)
    }
    module.hot.accept("./ScheduleEventAttachmentsInput.vue?vue&type=template&id=117b4027&", function () {
      api.rerender('117b4027', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/schedules/ScheduleEventAttachmentsInput.vue"
export default component.exports